export const USER_ERROR = 'USER_ERROR';
export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_SET_PROFILE_PHOTO = 'USER_SET_PROFILE_PHOTO';
export const USER_SET_AVAILABLE_SECTIONS = 'USER_SET_AVAILABLE_SECTIONS';
export const USER_SET_HAS_SETTINGS_ERRORS = 'USER_SET_HAS_SETTINGS_ERRORS';
export const USER_HIDE_WORK_ON_PC_MOBILE_POPUP = 'USER_HIDE_WORK_ON_PC_MOBILE_POPUP';
export const USER_SET_IMPORTANT_NOTIFICATION = 'USER_SET_IMPORTANT_NOTIFICATION';
